// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';
import { AI_SERVICE_URL } from 'config';
import { openSnackbar } from './snackbar';
import { DEFAULT_ERROR_MESSAGE } from 'store/constant';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    AILogsData: [],
    showAIModal: false
};

const slice = createSlice({
    name: 'aiLogs',
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setAiLogsData(state, action) {
            state.AILogsData = action.payload;
        },
        showModal(state, action) {
            state.showAIModal = action.payload;
        },
        resetAiLogs() {
            return initialState;
        }
    }
});

// Reducer
export default slice.reducer;
export const { showModal, resetAiLogs } = slice.actions;

// ----------------------------------------------------------------------
const BASE_URL = `${AI_SERVICE_URL}quotes/private/quote-step-rating/`;

export const getAILogs = (code, showLoader = true) => {
    if (showLoader) {
        dispatch(slice.actions.setIsLoading(true));
        dispatch(slice.actions.showModal(true));
    }
    return async () => {
        const url = `${BASE_URL}?requirement_code=${code}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'aiservice'
                }
            });
            dispatch(slice.actions.setAiLogsData(response?.data));
        } catch (errorMessage) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.showModal(false));
        } finally {
            dispatch(slice.actions.setIsLoading(false));
        }
    };
};
export const handlePatchRequest =
    (payload, id = '', code) =>
    async () => {
        const url = `${BASE_URL}${id}/`;
        try {
            const response = await axios.patch(url, payload, {
                headers: {
                    source: 'aiservice'
                }
            });
        } catch (errorMessage) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        } finally {
            dispatch(getAILogs(code, false));
        }
    };
